import { clientService } from '../helpers/api/api.service';

export const validateClientCode = async (clientCode: string): Promise<boolean> => {
    if (!clientCode) return false;

    try {
        const response = await clientService.getAllClients();
        if (response.status === 200 && Array.isArray(response.data) && response.data.length > 0) {
            return response.data.some((client) => client.code === clientCode);
        }
    } catch (error) {
        console.error('Error validating client:', error);
    }

    return false;
};
